import React from 'react';
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

export const AutocompleteSelect = ({id, value, name, content, label, setFieldValue, setFieldTouched, touched, error, helperText, sequenceNumber, ...props}) => {
    const onChange = (e, newValue) => {        
        setFieldValue(name, newValue)
        if (!touched && setFieldTouched) {
            setFieldTouched(name, true, false)
        }
    }


    return <Autocomplete
        id={`${id}`}
        fullWidth
        value={value}
        clearOnEscape
        options={content.choices}
        getOptionLabel={(option) => option.value}
        getOptionSelected={(option, value) => option.value === value.value}
                renderInput={(params) => <TextField {...params}
                                            variant={'outlined'}
                                            size={"small"}
                                            fullWidth
                                            error={touched && Boolean(error)}
                                            helperText={error && touched ? error : helperText}
                                            label={label}/>}
        {...props}
        onChange={onChange}

    />
}